import QuestionObj from '../Models/QuestionObj';

const ContractsWarranties_QSet = [    
    new QuestionObj({
        questionSet:{
            English: 'Are you able to automate the end-to-end process of claims management?',
            German: 'German Q1',
            French: "French Q1",
            Russian: "Russian Q1",
            Turkish: "Turkish Q1",
            Italian: "Italian Q1",
            Spanish: "Spanish Q1",
            PortugueseBR: "PortugueseBR Q1",
            SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                "No, we do not have this capability",
                "Yes, but it requires multiple disconnected systems and/or manual effort",
                "Yes, but it requires multiple integrated systems and data accuracy often cause invoicing errors",
                "Yes, this is a seamless process within our current environment",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50, 75, 100],   
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do your field service teams have real-time visibility into which entitlements are covered as part of a customer’s subscription?',
            German: 'German Q1',
            French: "French Q1",
            Russian: "Russian Q1",
            Turkish: "Turkish Q1",
            Italian: "Italian Q1",
            Spanish: "Spanish Q1",
            PortugueseBR: "PortugueseBR Q1",
            SpanishLAD: "SpanishLAD Q1",
        },
        answerSet:{
            English: [
                "No, we are not able to deliver entitlement data to our field technicians consistently",
                "We can deliver some of this data to our field technicians, but not consistently for every event or customer",
                "We can usually deliver this data to our field technicians, but accuracy can be an issue",
                "We can consistently deliver this data accurately to our field technicians",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50, 75, 100],   
    }),
    new QuestionObj({
        questionSet:{
            English: 'Can you easily apply contract discounts to ensure accurate invoicing?',
            German: 'German Q3',
            French: "French Q3",
            Russian: "Russian Q3",
            Turkish: "Turkish Q3",
            Italian: "Italian Q3",
            Spanish: "Spanish Q3",
            PortugueseBR: "PortugueseBR Q3",
            SpanishLAD: "SpanishLAD Q3",
        },
        answerSet:{
            English: [
                'No, we do not have this capability',
                'Yes, but it requires multiple disconnected systems and/or manual effort',
                'Yes, but it requires multiple integrated systems and data accuracy often causes invoicing errors',
                'Yes, this is a seamless process within our current environment'
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50, 75, 100],
    }),
    new QuestionObj({
        questionSet:{
            English: 'Do you have up-to-date and accurate information about your customer’s assets, including associated contracts/warranties?',
            German: 'German Q4',
            French: "French Q4",
            Russian: "Russian Q4",
            Turkish: "Turkish Q4",
            Italian: "Italian Q4",
            Spanish: "Spanish Q4",
            PortugueseBR: "PortugueseBR Q4",
            SpanishLAD: "SpanishLAD Q4",
        },
        answerSet:{
            English: [
                "No, we do not have this capability",
                "Yes, but it requires multiple disconnected systems and/or manual effort",
                "Yes, but it requires multiple integrated systems and data accuracy often causes friction",
                "Yes, this is a seamless process within our current environment"
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25,50,75, 100], 
    }),
    new QuestionObj({
        questionSet:{
            English: 'Are you able to define, schedule, and execute proactive maintenance service activities?',
            German: 'German Q5',
            French: "French Q5",
            Russian: "Russian Q5",
            Turkish: "Turkish Q5",
            Italian: "Italian Q5",
            Spanish: "Spanish Q5",
            PortugueseBR: "PortugueseBR Q5",
            SpanishLAD: "SpanishLAD Q5",
        },
        answerSet:{
            English: [
                "No, we do not have this capability",
                "Yes, but it requires multiple disconnected systems and/or manual effort",
                "Yes, but it requires multiple integrated systems and data accuracy often causes friction",
                "Yes, this is a seamless process within our current environment",
            ],
            German: [
                'German A ',
                'German B',
                'German C',
                'German D ',
            ],
            French: [
                'French A',
                'French B',
                'French C',
                'French D',
            ],
            Russian: [
                'Russian A',
                'Russian B',
                'Russian C',
                'Russian D',
            ],
            Turkish: [
                'Turkish A',
                'Turkish B',
                'Turkish C',
                'Turkish D',
            ],
            Italian: [
                'Italian A',
                'Italian B',
                'Italian C',
                'Italian D',
            ],
            Spanish: [
                'Spanish A',
                'Spanish B',
                'Spanish C',
                'Spanish D',
            ],
            PortugueseBR: [
                'PortugueseBR A',
                'PortugueseBR B',
                'PortugueseBR C',
                'PortugueseBR C ',
            ],
            SpanishLAD: [
                'SpanishLAD A',
                'SpanishLAD B. ',
                'SpanishLAD C',
                'SpanishLAD D',
            ]
        },
        custVals: [25, 50, 75, 100],
    }),
];

export default ContractsWarranties_QSet;